module.exports = __webpack_public_path__ + "img/megapot_color.ca5f0f3b.svg";